import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { IBookPrice } from 'src/app/data/books/prices/types';
import { BehaviorSubject } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import Subscriber from 'src/app/subscriber';

const sub = new Subscriber();

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultComponent implements OnInit, OnDestroy {
  @Input() id: string;

  @Input() title: string;

  @Input() specs: { [key: string]: string };

  @Input() price?: IBookPrice;

  @Input() photo: string;

  @Input() discount?: string;

  public Object = Object;

  get specsKeys(): string[] {
    return Object.keys(this.specs);
  }

  public isLtXl = new BehaviorSubject<boolean>(false);

  constructor(private _media: MediaObserver) {}

  ngOnInit(): void {
    sub.push(
      this._media.asObservable().subscribe(() => {
        this._updateIsLtXl();
      }),
    );
  }

  ngOnDestroy(): void {
    sub.unsubscribe();
  }

  private _updateIsLtXl(): void {
    this.isLtXl.next(this._media.isActive('lt-xl'));
  }
}
